import { DollarSign, BarChart3, Target, Users, Zap, TrendingUp, TrendingDown } from "lucide-react";

export const formatCurrency = (value = 0) => {
  const n = Number(value) || 0;
  if (n >= 1000000) return `$${(n / 1000000).toFixed(1)}M`;
  if (n >= 1000) return `$${(n / 1000).toFixed(0)}K`;
  return `$${n.toFixed(0)}`;
};

export const formatDate = (dateString) =>
  dateString ? new Date(dateString).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" }) : "Not set";

export const daysUntil = (dateString) => {
  if (!dateString) return null;
  return Math.ceil((new Date(dateString) - new Date()) / (1000 * 60 * 60 * 24));
};

export const getGoalIcon = (type, name) => {
  if (type === "revenue") return DollarSign;
  if (type === "pipeline") return BarChart3;
  if (type === "conversion" || name?.includes("Opportunit")) return Target;
  if (name?.includes("Lead")) return Users;
  if (name?.includes("Activit")) return Zap;
  return Target;
};

const STATUS_COLORS = {
  completed: "text-green-400 bg-green-500/20",
  in_progress: "text-ism-teal bg-ism-teal/20",
  at_risk: "text-red-400 bg-red-500/20",
};
export const statusColor = (status) => STATUS_COLORS[status] || "text-gray-400 bg-gray-500/20";

export const progressColor = (progress) => {
  if (progress >= 100) return "bg-green-500";
  if (progress >= 75) return "bg-ism-teal";
  if (progress >= 50) return "bg-amber-500";
  if (progress >= 25) return "bg-orange-500";
  return "bg-red-500";
};

export const getPacing = (progressPercentage) => {
  if (progressPercentage >= 90) return { status: "Ahead", icon: TrendingUp, color: "text-green-400" };
  if (progressPercentage >= 60) return { status: "On Pace", icon: Target, color: "text-ism-teal" };
  return { status: "Behind", icon: TrendingDown, color: "text-red-400" };
};

export const DEFAULT_CREATE_FORM = {
  revenueGoal: 1000000,
  deadline: new Date(new Date().getFullYear(), 11, 31).toISOString().split("T")[0],
  leadToOpportunity: 0.25,
  opportunityToProposal: 0.5,
  proposalToClose: 0.3,
  averageDealSize: 50000,
};
